<template>
  <AdminModal
    :is-open="isOpen"
    modalSize="lg"
    :modal-title="`수업 상세`"
    :close="close"
    name="lessonDetailModal"
  >
    <b-container>
      <b>{{title}}</b>
      <div class="mt-2">
        <div class="mt-1"
             :key="index"
             v-for="(lessonContent, index) in lessonContents">
          <LessonDetailCollapse
            :lessonContent="lessonContent"/>
        </div>
      </div>
    </b-container>
  </AdminModal>
</template>
<script>
import AdminModal from "@/components/modals/AdminModal.vue";
import api from "@/api/api";
import LessonDetailCollapse from "@/components/LessonDetailCollapse";

export default {
  name: "LessonDetailModal",
  components: {LessonDetailCollapse, AdminModal},
  props: ['isOpen', 'lesson', 'reload', 'close'],
  data() {
    return {
      id: '',
      title: '',
      lessonContents: []
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      api.lesson.lessonDetail({id: this.lesson.id},
        (response) => {
        const {id, title, lessonContents} = response.data
          this.id = id
          this.title = title
          this.lessonContents = lessonContents
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>

</style>